import React from 'react';
import TextArea from 'components/TextArea';
import withSetting from './SettingsHOC';

function CustomTextArea(props) {
  const { onChange, value, dataCy } = props;

  return (
    <TextArea
      onChange={onChange}
      value={value || ''}
      dataCy={dataCy ? `${dataCy}-text-area`.replace(/ /g, '_') : ''}
    />
  );
}

export default withSetting(CustomTextArea);
